/**
 * zip-iterator
 *
 * Extract contents from ZIP archives using an iterator API.
 * Supports streaming and path inputs with forward-only parsing.
 */

export * from './types.ts';
export { default } from './ZipIterator.ts';
